import React from 'react'
import Helmet from 'react-helmet'

const WebComponentHeader = (props) => {
  return (
    <>
      <Helmet>
        <script type="module" src="/static/dfb-web-components.js" />
      </Helmet>
      <dfb-header
        src={`/navigation/mainNavigation-${props?.language || 'de'}.json`}
        brand={props.brand}
        enableLogin={props?.language !== 'en'}
        enableSearch={props?.language !== 'en'}
        enableNotification={!!process.env.EMARSYS_APPLICATION_CODE}
      ></dfb-header>
    </>
  )
}

export default WebComponentHeader
